import Echo from 'laravel-echo';
import Pusher from 'pusher-js';
import { env } from 'shared/env';

import { api } from './api';

declare global {
  interface Window {
    Pusher: typeof Pusher;
    Echo?: Echo;
  }
}

if (!window.Pusher) {
  window.Pusher = Pusher;
}

type Channel = {
  name: string;
  token: string;
};

type Callback = (isError: boolean, data: unknown) => void;

let echoInstance: Echo | null = null;

export function getEcho(): Echo {
  if (echoInstance) return echoInstance;

  echoInstance = new Echo({
    broadcaster: 'reverb',
    key: env('REACT_APP_REVERB_APP_KEY'),
    wsHost: env('REACT_APP_REVERB_HOST'),
    wsPort: env('REACT_APP_REVERB_PORT'),
    wssPort: env('REACT_APP_REVERB_WSS_PORT'),
    forceTLS: (env('REACT_APP_REVERB_SCHEME') ?? 'https') === 'https',
    enabledTransports: ['ws', 'wss'],
    authorizer: (channel: Channel) => ({
      authorize: (socketId: string, callback: Callback) => {
        api
          .post('/broadcasting/auth', {
            socket_id: socketId,
            channel_name: channel.name,
          })
          .then((response) => callback(false, response.data))
          .catch((error) => callback(true, error));
      },
    }),
  });

  window.Echo = echoInstance;
  return echoInstance;
}

export function leaveChannel(channel: string): void {
  const echo = getEcho();
  echo.leave(channel);
}
